import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { navigateAfterRedsys } from "services/api/redsys.service";

export function ResponseOkGlobick(){
    const { action } = useParams();
    console.log("action OK GLOBICK",action)
    useEffect(()=>{
        //const {processId, paymentDataUid} = unMountParams();
        // console.log(processId, paymentDataUid);
      
        navigateAfterRedsys();
    })

    const unMountParams = ()=>{
        const input = window.location.search;
        if( input ){
            const paramsUnMounted =  input.split("?")[1];
            const paramsStrings = paramsUnMounted.split("&");
            const processId = paramsStrings[0].split("processId=")[1]
            const paymentDataUid = paramsStrings[1].split("paymentDataUid=")[1]
            return {processId, paymentDataUid};
        }else {
            return {processId:"null", signatureVersion:"null", paymentDataUid: "null"}
        }
    }
    return(
        <>
        <div>

        </div>
        </>
    )
}